<script lang="ts">
  import css from "../../../../css/comments.pcss.json";
  import type { CommentAttachment } from "../../comments/CommentTypes";

  export let attachment: CommentAttachment
  export let onlyAttachment: boolean = false

  const classes = [css['comment__attachment__image']]
  let imgSrc = attachment.preview_url

  if (onlyAttachment) {
    classes.push(css['comment__attachment--only'])
  }

  const onError = () => {
    classes.push(css['comment__attachment__image--not-loaded'])
  }
</script>

<a
    class={classes.join(' ')}
    href={attachment.url}
    target="_blank"
    data-lightbox-children
    rel="nofollow ugc"
>
    <div class={css['comment__attachment__inner']}>
        <img
            alt=""
            src={imgSrc}
            on:error={onError}
            loading="lazy"
        />
        <div class={css['comment__attachment__image__zoom']}>
            <svg viewBox='0 0 28 28' fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.56 13.06h5M13.06 10.56v5M13.06 19.63a6.56 6.56 0 1 0 0-13.13 6.56 6.56 0 0 0 0 13.13ZM17.7 17.7l3.8 3.8"
                    stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <slot name="delete"></slot>
    </div>
</a>
